import './navbarItem.scss'
import clsx from 'clsx'
import { NavLink } from 'react-router'
// import { useState } from 'react';

export const NavbarItem = ({
    to,
    icon,
    text,
    isOpen,
    isChild,
    disabled,
    className,
    classNameText,
}: {
    to: string
    icon: string
    text: string
    isOpen: boolean
    isChild?: boolean
    disabled?: boolean
    className?: string
    classNameText?: string
}) => {
    // const [showTooltip, setShowTooltip] = useState(true);
    // const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const tooltipText = 'Этому аккаунту ограничен доступ в этот раздел'

    // const handleMouseEnter = () => {
    //     if (disabled) {
    //         setShowTooltip(true);
    //     }
    // };

    // const handleMouseLeave = () => {
    //     setShowTooltip(false);
    // };

    // const handleMouseMove = (e: React.MouseEvent) => {
    //     if (showTooltip) {
    //         const element = e.currentTarget as HTMLElement;
    //         const rect = element.getBoundingClientRect();
    //         const offsetX = e.clientX - rect.left;
    //         const offsetY = e.clientY - rect.top;
    //         setTooltipPosition({
    //             x: offsetX,
    //             y: offsetY,
    //         });
    //         console.log("e.clientX", e.clientX, e.clientY, rect.left, rect.top)
    //         // setTooltipPosition({
    //         //     x: e.clientX,
    //         //     y: e.clientY,
    //         // });
    //     }
    // };

    const handleClick = (e: React.MouseEvent) => {
        if (disabled) {
            e.preventDefault() // Prevent default click action (navigation)
        }
    }

    return (
        <NavLink
            to={disabled ? '#' : to}
            className={({ isActive }) =>
                clsx(
                    'navbar-item',
                    {
                        disabled,
                        active: !disabled && isActive,
                        child: isChild,
                        closed: !isOpen,
                        open: isOpen,
                    },
                    className
                )
            }
            title={disabled ? tooltipText : undefined}
            onClick={handleClick}
        >
            <img src={icon} alt={text} className="navbar-item__icon" />
            <p
                className={clsx(
                    'navbar-item__text',
                    { closed: !isOpen },
                    classNameText
                )}
            >
                {text}
            </p>
        </NavLink>
    )
}
